import React, { SVGProps } from 'react';

export default function SquareFitIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      id="Icons"
      viewBox="0 0 74 74"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="m61.13 47.44a1 1 0 0 1 -1-1v-2.91a1 1 0 0 1 2 0v2.91a1 1 0 0 1 -1 1z" />
      <path d="m61.13 62.13h-48.26a1 1 0 0 1 -1-1v-48.26a1 1 0 0 1 1-1h48.26a1 1 0 0 1 1 1v13.69a1 1 0 0 1 -2 0v-12.69h-46.26v46.26h46.26v-6.69a1 1 0 0 1 2 0v7.69a1 1 0 0 1 -1 1z" />
      <path d="m61.13 37.53a1 1 0 0 1 -1-1v-2.97a1 1 0 0 1 2 0v2.97a1 1 0 0 1 -1 1z" />
      <path d="m61.129 8.387a1 1 0 0 1 -1-1v-4.387a1 1 0 1 1 2 0v4.387a1 1 0 0 1 -1 1z" />
      <path d="m12.871 8.387a1 1 0 0 1 -1-1v-4.387a1 1 0 0 1 2 0v4.387a1 1 0 0 1 -1 1z" />
      <path d="m61.129 72a1 1 0 0 1 -1-1v-4.387a1 1 0 0 1 2 0v4.387a1 1 0 0 1 -1 1z" />
      <path d="m12.871 72a1 1 0 0 1 -1-1v-4.387a1 1 0 0 1 2 0v4.387a1 1 0 0 1 -1 1z" />
      <path d="m71 62.129h-4.387a1 1 0 0 1 0-2h4.387a1 1 0 0 1 0 2z" />
      <path d="m71 13.871h-4.387a1 1 0 0 1 0-2h4.387a1 1 0 0 1 0 2z" />
      <path d="m7.387 62.129h-4.387a1 1 0 1 1 0-2h4.387a1 1 0 1 1 0 2z" />
      <path d="m7.387 13.871h-4.387a1 1 0 0 1 0-2h4.387a1 1 0 1 1 0 2z" />
    </svg>
  );
}
